/**
  Navigates to "/" to trigger route resolver AuthService.skipIfLoggedIn() which redirects logged-in users to home.
  
  Can't use goToHomePage() + reloadPage() because applyAsyncFunc() defers navigation via $timeout. 
  Calling reloadPage() immediately reloads before navigation completes, restoring previous URL.
  
  window.location.replace('/') bypasses async navigation, immediately navigates to "/", resolver runs on load.
*/
export const goToHomePageWithReload = () => {
  window.location.replace('/');
};
// can't test this function because can't mock window.location after JSDOM v26
